import { AxiosError } from 'axios';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePostManualTreeExcerptstatus } from '../../../../../../api/manual-tree/manual-tree';
import { ErrorInfo } from '../../../../../../api/model';
import { useDefaultOptions } from '../../../../../../hooks/api';
import ConfirmModal from '../../../../../modules/ConfirmModal';
import ErrorModal from '../../../../../modules/ErrorModal';
import SpinnerModal from '../../../../../modules/SpinnerModal';

type TreeProps = {
  productionId: number;
  chapterId: number | undefined;
  sectionId: number | undefined;
  level: number | undefined;
  title: string | undefined;
  excerptcolorRefetch: () => void;
};
function SectionSlimMenu({ productionId, chapterId, sectionId, level, title, excerptcolorRefetch }: TreeProps) {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const options = useDefaultOptions(language);

  // #region UI操作系
  const [displayConfirm, setDisplayConfirm] = useState(false); // 確認メッセージ
  const [updateStatus, setUpdateStatus] = useState(0); // 薄型OM更新ステータス
  const confirmMessage = useMemo(() => {
    if (updateStatus === 1) {
      return t('紙OMに残す');
    }
    if (updateStatus === 2) {
      return t('紙OMに残す(配下全て)');
    }
    return t('紙OMに残さない');
  }, [updateStatus, t]);
  // #endregion

  // #region 更新処理系
  const [displayError, setDisplayError] = useState(false);
  const { mutateAsync, isLoading, isError, error } = usePostManualTreeExcerptstatus<AxiosError<ErrorInfo>, unknown>(
    options
  );
  useEffect(() => {
    setDisplayError(isError);
  }, [isError]);

  // ステータス更新
  const handleUpdate = useCallback(async () => {
    await mutateAsync(
      { productionId, data: { chapter_id: chapterId, section_id: sectionId, level, update_status: updateStatus } },
      {
        onSuccess: () => {
          excerptcolorRefetch(); // 再読込み（色情報だけ更新）
        },
      }
    );
  }, [mutateAsync, excerptcolorRefetch, productionId, chapterId, sectionId, level, updateStatus]);
  // #endregion

  return (
    <>
      <li>
        <ul className="gnav">
          <li>
            <i className="fa-regular fa-square-check" />
            {t('紙OM抜粋')}
            <ul style={{ width: language === 'ja' ? '' : '250px' }}>
              <li
                onClick={() => {
                  setDisplayConfirm(true);
                  setUpdateStatus(1);
                }}
              >
                {t('紙OMに残す')}
              </li>
              <li
                onClick={() => {
                  setDisplayConfirm(true);
                  setUpdateStatus(2);
                }}
              >
                {t('紙OMに残す(配下全て)')}
              </li>
              <li
                onClick={() => {
                  setDisplayConfirm(true);
                  setUpdateStatus(3);
                }}
              >
                {t('紙OMに残さない')}
              </li>
            </ul>
          </li>
        </ul>
      </li>
      {/* スピナーモーダル */}
      {isLoading && <SpinnerModal />}
      {/* 原稿プレビュー */}
      {displayError && <ErrorModal error={error} onClickOk={() => setDisplayError(false)} />}
      {/* 更新前の確認メッセージ */}
      {displayConfirm && (
        <ConfirmModal
          onClickCancel={() => setDisplayConfirm(false)}
          onClickOk={async () => {
            setDisplayConfirm(false);
            await handleUpdate();
          }}
        >
          {t('L')}
          {String(level)}
          {t('「')}
          {title}
          {t('」を「')}
          {confirmMessage}
          {t('」に指定しますか？')}
        </ConfirmModal>
      )}
    </>
  );
}
export { SectionSlimMenu };
